<template>
    <div>
        <div class="container text-center mt-5">
            <div id="header" class="text-center">
                <h1>Multi SQL</h1>
                <p>Executa um script SQL em todas as bases selecionadas</p>
            </div>
            <div id="header" class="text-center">
                <label for="txtsistema">Selecione qual sistema quer atualizar:</label>
                <div class="d-flex justify-content-center">
                    <select id="txtsistema" name="txtsistema" class="form-control w-50 " @change="selectSistema($event)">
                        <option value="I">GInfo (Bases Hostinger)</option>
                        <option value="T">GTrans (Bases OPTIDATA)</option>
                        <option value="C">GTrans CT-e (Bases 3xdata 3xdata_cliente)</option>
                        <option value="G">GTrans Completo (Bases 3xdata 3xdata_a-cliente)</option>
                    </select>
                </div>
            </div>

            <!-- <b-card class="mt-4"> -->
            <p class="card-text mt-4">Escreva seu script SQL aqui:</p>
            <b-form-textarea id="textarea" v-model="textScript" rows="10" max-rows="6"
                placeholder="Escreva seu script aqui"></b-form-textarea>
        </div>

        <div class="container mt-4">
            <div class="container text-center">
                <div class="container">
                    <div class="form-group">
                        <label>
                            <strong>Bases de dados</strong>
                            <br>Selecione abaixo as bases de dados em que deseja executar o script
                        </label>
                        <table class="table table-striped">
                            <thead>
                                <th><input type="checkbox" name="" id="checkTodos" @click="marcarTodos"> Todos</th>
                                <th>#</th>
                                <th>Nome Base</th>
                            </thead>
                            <tbody id="databases-list">
                                <tr v-for="(base, index) in bases" :key="base.id">
                                    <td>
                                        <input @click="insertBase(base)" type="checkbox">
                                    </td>
                                    <td>{{ index }}</td>
                                    <td>{{ base.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr>
                    <div class="form-group">
                        <div class="row">
                            <div v-if="showLoader" class="c-loader" id="c-loader"></div>

                            <div class="col-md-12">
                                <button type="button" class="btn btn-success float-right"
                                    @click="submitScript">Executar</button>
                            </div>
                        </div>
                    </div>
                    <strong>RETORNO</strong>

                    <textarea id="execution-result" rows="15" class="col-md-12 form-control mb-5" />
                </div>

            </div>
        </div>

    </div>
</template>
  
<script>

export default {
    components: {
    },
    data() {
        return {
            data: [],
            selectedBase: [],
            textScript: "",
            selectedItems: [],
            executionResult: '',
            arrayBases: [],
            tp_base: 'I',
            showLoader: false
        };
    },
    computed: {
        bases() {
            return this.$store.getters['frotaItem/getBases']
        }
    },

    methods: {
        marcarTodos() {
            let checkTodos = document.getElementById('checkTodos')
            let checkbox = document.querySelectorAll('input[type=checkbox]')
            if (checkTodos.checked == true) {
                this.selectedItems = this.arrayBases.slice()
            } else {
                this.selectedItems = []
            }

            checkbox.forEach((element) => {
                if (checkTodos.checked == true) {
                    element.checked = true
                } else {
                    element.checked = false
                }
            })
        },

        insertBase(base) {
            const pesqBase = this.selectedItems.findIndex(objeto => objeto.name === base.name)

            if (pesqBase !== -1) {
                this.selectedItems.splice(pesqBase, 1)
            } else {
                this.selectedItems.push(base)
            }
        },

        submitScript() {
            this.showLoader = true
            this.exibePaginacao = false

            const script = this.textScript.replaceAll('\n', '')

            const dataScript = {
                script: script,
                database: this.selectedItems,
                tp_base: this.tp_base
            }

            this.$store.dispatch('frotaItem/executarScriptBase', { data: dataScript }).then(response => {
                try {
                    if (response.data) {
                        this.$swal.fire({
                            title: 'Sucesso!',
                            text: 'Seu script rodou com sucesso!',
                            icon: 'success'
                        })


                        document.getElementById('execution-result').value = JSON.stringify(response.data, null, 4)

                    } else if (response) {
                        document.getElementById('execution-result').value = response.response.data[1]

                        this.$swal.fire({
                            title: 'Oops!',
                            text: 'Houve algum problema no script!',
                            icon: 'error'
                        })
                    }
                } catch (error) {
                    this.$swal.fire({
                        title: 'Oops!',
                        text: 'Houve algum problema no script!',
                        icon: 'error'
                    })
                }

                this.showLoader = false

            })
        },

        selectSistema(sistema) {
            this.selectedItems = []
            document.getElementById('checkTodos').checked = false

            let checkbox = document.querySelectorAll('input[type=checkbox]')

            checkbox.forEach((element) => {
                element.checked = false
            })

            this.arrayBases = []

            this.tp_base = sistema.srcElement.value
            const data = {
                tp_base: sistema.srcElement.value,
            }

            this.selectBases(data)
        },

        selectBases(data) {
            this.$store.dispatch('frotaItem/selectBases', { data: data }).then((response) => {
                this.arrayBases = response
            })
        },
    },

    created() {
        const data = {
            tp_base: 'I',
        }

        this.selectBases(data)
        // this.arrayBases = this.bases
    }
};
</script>


<style>
.c-loader {
    animation: is-rotating 1s infinite;
    border: 6px solid #e5e5e5;
    border-radius: 50%;
    border-top-color: #51d4db;
    height: 50px;
    width: 50px;
}
@keyframes is-rotating {
  to {
    transform: rotate(360deg);
  }
}

/* Adicionando prefixos para suporte a navegadores */
@-webkit-keyframes is-rotating {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-moz-keyframes is-rotating {
  to {
    -moz-transform: rotate(360deg);
  }
}
</style>